<template>
  <div>
    <div class="text-h6 mt-2 mb-3 d-block d-md-none">
      <v-icon color="grey" style="margin-bottom: 3px;">mdi-code-tags</v-icon>
      {{ $t('title') }}
    </div>

    <v-alert v-if="$account.getSubscription('check-position').name === 'default'" type="warning" text>
      {{ $t('free-not-allowed') }}
      <router-link to="/account/subscriptions">{{ $t('free-not-allowed-link') }}</router-link>
    </v-alert>
    <a-api-widget v-else></a-api-widget>
  </div>
</template>

<script>
export default {
  name: 'ApiPage'
}
</script>

<i18n>
{
	"en": {
		"free-not-allowed": "API access is reserved for subscribed accounts.",
		"free-not-allowed-link": "Subscribe to an offer to activate this feature.",
		"title": "Api"
	},
	"es": {
		"free-not-allowed": "El acceso a la API está reservado para las cuentas suscritas.",
		"free-not-allowed-link": "Suscríbete a una oferta para activar esta función.",
		"title": "Api"
	},
	"fr": {
		"free-not-allowed": "L'accès API est réservé aux comptes avec souscription.",
		"free-not-allowed-link": "Souscrivez à une offre pour activer cette fonctionnalité.",
		"title": "Api"
	},
	"it": {
		"free-not-allowed": "L'accesso API è riservato agli account con abbonamento.",
		"free-not-allowed-link": "Abbonati a un'offerta per attivare questa funzionalità.",
		"title": "Api"
	},
	"pt": {
		"free-not-allowed": "O acesso à API está reservado para contas com subscrição.",
		"free-not-allowed-link": "Subscreva uma oferta para ativar esta funcionalidade.",
		"title": "Api"
	},
	"pl": {
		"free-not-allowed": "Dostęp do API jest zarezerwowany dla kont z subskrypcją.",
		"free-not-allowed-link": "Zasubskrybuj ofertę, aby aktywować tę funkcję.",
		"title": "Api"
	}
}
</i18n>



